import axios from 'axios';

export default {
  getAll() {
    return axios.get('/users');
  },
  create(body) {
    return axios.post('/users', body);
  },
  update(id, body) {
    return axios.patch(`/users/${id}`, body);
  },
  recruiters() {
    return axios.get('/users/recruiters');
  },
  sourcers() {
    return axios.get('/users/sourcers');
  },
  techInterviewers() {
    return axios.get('/users/tech-interviewers');
  },
};
